//
//
//
//
//
//
//
//
//
//
//

import { Work } from "@/models";
import ListItem from "@/components/ListItem.vue";

export default {
  name: "Item",
  created() {
    let id = this.$route.params.id;

    if (!id) {
      return;
    }

    this.workId = id

    Work.getById(id).then(work => {
      this.work = work;
    });

    this.getLists();
  },
  scrollBottom() {
    this.getLists(this.page + 1);
  },
  metaInfo() {
    return {
      title: "诗单"
    };
  },
  props: [],
  data() {
    return {
      workId: null,
      work: null,
      lists: [],
      loading: false,
      page: 1
    };
  },
  methods: {
    getLists: function(page = 1) {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      Work.getLists(this.workId, page)
        .then(lists => {
          if (page == 1) {
            this.lists = lists;
          } else {
            this.lists = this.lists.concat(lists);
          }

          this.loading = false;
          this.page = page;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  components: {
    ListItem
  }
};



// WEBPACK FOOTER //
// ./src/pages/WorkLists.vue